import _ from 'lodash';

/**
 * 默认注释输入框高度 200
 */
const DEFAULT_HEIGHT = 200;

/**
 * A composable function that provides caching functionality for the height of a comment textarea.
 */
export function useCacheCommentTextareaHeight() {
    const KEY_CACHE_HEIGHT = 'WS:CommentFooterHeight';

    /**
     * Saves the height of the comment textarea to the cache.
     * @param height The height of the comment textarea.
     */
    function saveHeightToCache(height: number) {
        localStorage.setItem(KEY_CACHE_HEIGHT, height.toString());
    }

    /**
     * Retrieves the height of the comment textarea from the cache.
     * If the height is not found in the cache, it returns a default height of 200.
     * @returns The height of the comment textarea.
     */
    function getHeightFromCache() {
        const value = localStorage.getItem(KEY_CACHE_HEIGHT);
        if (!value) {
            return DEFAULT_HEIGHT;
        }
        const height = _.toNumber(value);
        return height;
    }

    return {
        /**
         * Saves the height of the comment textarea to the cache.
         */
        saveHeightToCache,
        /**
         * Retrieves the height of the comment textarea from the cache.
         * If the height is not found in the cache, it returns a default height of 200.
         * @returns The height of the comment textarea.
         */
        getHeightFromCache,
    };
}
